$(() => {
  const pluginName = 'promoCodesPlugin';
  const dataKey = `plugin_${pluginName}`;
  let $pluginContainer = null;

  const Plugin = function plugin(element) {
    this.element = element;
    this.settings = {
      registrationPlugin: null,
      registrationUrl: null,
      i18n: {},
    };

    // Set the container for the plugin
    $pluginContainer = element;
  };

  /**
   * Clear the plugin's contents
   */
  Plugin.prototype.clear = () => {
    $pluginContainer.empty();
  };

  /**
   * Display the plugin's contents
   * @param content
   */
  Plugin.prototype.displayContent = (content) => {
    if (content) {
      $pluginContainer.html(content);
    }
  };

  /**
   * Initialize the functional components of the content
   */
  Plugin.prototype.initializeContent = () => {
    Plugin.prototype.displayContent();
  };

  /**
   * Toggle the visibility of this component
   *
   * @param isVisible
   */
  Plugin.prototype.toggleVisibility = (isVisible) => {
    $pluginContainer.toggleClass('hidden', !isVisible);
  };

  /**
   * Plugin wrapper, preventing against multiple instantiations and
   * return plugin instance.
   */
  $.fn[pluginName] = function pluginWrapper(options) {
    let plugin = this.data(dataKey);

    // has plugin instantiated ?
    if (plugin instanceof Plugin) {
      // if have options arguments, call plugin.init() again
      if (typeof options !== 'undefined') {
        plugin.init(options);
      }
    } else {
      plugin = new Plugin(this, options);
      this.data(dataKey, plugin);
    }

    return plugin;
  };
});
